import React, { useState } from "react";
import { GoogleLogin } from "@react-oauth/google";
import axios from "axios";
import "./LoginScreen.css";
import LogoImage from "./assets/logo_title.png";

export default function LoginScreen({ onAuthSuccess }) {
  const [isLoading, setIsLoading] = useState(false);

  const handleSuccess = async (credentialResponse) => {
    setIsLoading(true);
    try {
      const idToken = credentialResponse.credential;
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}/auth/oauth`,
        { provider: "google", token: idToken },
        { headers: { "Content-Type": "application/json" } }
      );

      const { token: accessToken, refreshToken, user, isNewUser } = res.data;

      // JWT 토큰 콘솔 출력 (임시 디버깅용)
      console.log("Access Token:", accessToken);
      console.log("Refresh Token:", refreshToken);

      onAuthSuccess({
        user,
        isNewUser,
        signupToken: accessToken,
        refreshToken,
      });
    } catch (err) {
      console.error("❌ OAuth 로그인 에러:", err.response?.data || err);
      alert("로그인에 실패했습니다.");
    } finally {
      setIsLoading(false);
    }
  };

  const handleError = () => {
    alert("로그인을 취소했거나 오류가 발생했습니다.");
  };

  return (
    <div className="login-container">
      <div className="login-content">
       {/* 로고 이미지 하나만 */}
        <img src={LogoImage} alt="Questa Logo" className="login-logo" />
        <p className="login-subtitle"></p>
        <div className="login-button-wrapper">
          <GoogleLogin
            onSuccess={handleSuccess}
            onError={handleError}
            render={(renderProps) => (
              <button
                className={`login-button ${isLoading ? "loading" : ""}`}
                onClick={renderProps.onClick}
                disabled={renderProps.disabled || isLoading}
              >
                {isLoading ? (
                  <span className="spinner"></span>
                ) : (
                  <>
                    <span className="google-icon">G</span>
                    Google로 계속하기
                  </>
                )}
              </button>
            )}
          />
        </div>
      </div>
    </div>
  );
}